import React, {useState, useEffect} from "react";
import styled from "styled-components"
import { useNavigate } from "react-router-dom";
import useTokenStore from "../Store/Store";
const Styled={
    Wrap:styled.div`
        width:100%;
        height:70px;
        display:flex;
        justify-content:center;
        align-items:center;
        flex-direction:row;
        position:fixed;
        bottom:0px;
        background-color:#ffffff;
        z-index:3;
    `,
        ContentWrap:styled.div`
            width:82%;
            height:50px;
            display:flex;
            justify-content:space-between;
            align-items:center;
            flex-direction:row;
        `,
            ChoiceText:styled.p`
                font-size:18px;
                font-weight:bold;
                color:#000000;
                margin:0px;
                font-family:'PreFont';
            `,
            CartBox:styled.div`
                width:75%;
                height:50px;
                border-radius:10px;
                background-color:#2277F6;
                display:flex;
                justify-content:center;
                align-items:center;
                flex-direction:row;
            `,
                CartText:styled.p`
                    font-size:16px;
                    font-weight:400;
                    color:#ffffff;
                    margin:0px;
                    font-family:'PreFont';
                `,

}
const Footer=()=>{
    const navigate = useNavigate();
    const {
        Pocket,
        setPocket
    } = useTokenStore()
    return(
        <Styled.Wrap>
            <Styled.ContentWrap>
                <Styled.ChoiceText>선택: {Pocket.length}</Styled.ChoiceText>
                <Styled.CartBox onClick={()=>{navigate("/cart")}}>
                    <Styled.CartText>카트 보기</Styled.CartText>
                </Styled.CartBox>
            </Styled.ContentWrap>
        </Styled.Wrap>
    )
}
export default Footer